var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notification-detail" }, [
    _c("div", { staticClass: "custom-breadcrumbs" }, [
      _c("span", { staticClass: "back-link", on: { click: _vm.onClickBack } }, [
        _vm._v(_vm._s(_vm.$t("menu.notifications"))),
      ]),
      _c("span", { staticClass: "separator" }, [_vm._v(" / ")]),
      _c("span", { staticClass: "current-page" }, [
        _vm._v(_vm._s(_vm.$t("components.detail"))),
      ]),
    ]),
    _c("div", { staticClass: "detail-container" }, [
      _c("div", { staticClass: "top-container" }, [
        _c("div", { staticClass: "banner-content" }, [
          _c("div", { staticClass: "text-content" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(" " + _vm._s(_vm.detailData.title) + " "),
            ]),
            _c("div", { staticClass: "date" }, [
              _vm._v(_vm._s(_vm.detailData.notice_actual_time)),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "content-section" },
        [
          _c("div", { staticClass: "content-label" }, [
            _vm._v(_vm._s(_vm.$t("no_auth.notification_content"))),
          ]),
          _c("p", { staticClass: "txt" }, [
            _vm._v(_vm._s(_vm.detailData.content)),
          ]),
          _vm.detailData.type === 1 && _vm.detailData.data
            ? _c("ChannelFee", {
                attrs: { "fee-data": JSON.parse(_vm.detailData.data) },
              })
            : _vm._e(),
          _vm.detailData.notice_file_resp_list &&
          _vm.detailData.notice_file_resp_list.length > 0
            ? _c("div", { staticClass: "attachment-section" }, [
                _c("div", { staticClass: "attachment-title" }, [
                  _vm._v(_vm._s(_vm.$t("no_auth.attachment"))),
                ]),
                _c(
                  "div",
                  { staticClass: "attachment-list" },
                  _vm._l(
                    _vm.detailData.notice_file_resp_list,
                    function (file, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "attachment-item" },
                        [
                          _c("i", { staticClass: "el-icon-document" }),
                          _c("span", { staticClass: "file-name" }, [
                            _vm._v(_vm._s(file.file_name)),
                          ]),
                          _c(
                            "el-button",
                            {
                              staticClass: "download-btn",
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.downloadFile(
                                    file.file_oss_url,
                                    file.file_name
                                  )
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-download" })]
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }